/* ==========================================================================
   Boreal Gaming — card condition picker + grid toolbar sort (v2.1)
   Works with snippets/collection-grid-item-bgc.liquid. When a shopper changes
   the condition on a singles card, updates the card's price, compare-at price,
   stock badge and the Add button. The Add button itself is handled by the
   theme's existing [data-card-atc] quick-add code in custom.js.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__bgcCardPicker) return;
  window.__bgcCardPicker = true;

  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.matches || !sel.matches('.bgc-qa select')) return;

    var opt = sel.options[sel.selectedIndex];
    var card = sel.closest('.productCard__card');
    if (!opt || !card) return;

    var title = opt.getAttribute('data-title') || '';

    // Add button -> selected version
    var btn = card.querySelector('.bgc-qa__add');
    if (btn) {
      btn.setAttribute('data-variant-id', opt.value);
      btn.setAttribute('data-variant-title', title);
      btn.setAttribute('data-max', opt.getAttribute('data-max') || '');
    }

    // Price + compare-at
    var price = card.querySelector('[data-card-price]');
    var priceText = opt.getAttribute('data-price');
    if (price && priceText) price.textContent = priceText;

    var compare = card.querySelector('[data-card-compare]');
    if (compare) {
      var compareText = opt.getAttribute('data-compare') || '';
      compare.textContent = compareText;
      compare.hidden = !compareText;
    }

    // Stock badge -> selected version's count
    var badge = card.querySelector('[data-card-stock]');
    var qty = opt.getAttribute('data-qty');
    if (badge && qty !== null && qty !== '') {
      var n = parseInt(qty, 10);
      var lowAt = parseInt(badge.getAttribute('data-low-at') || '2', 10);
      var redAt = parseInt(badge.getAttribute('data-red-at') || '0', 10);
      var low = n <= lowAt;
      badge.textContent = low ? 'Only ' + n + ' left' : 'In stock';
      badge.classList.toggle('inventory--low', low);
      badge.classList.toggle('inventory--last', n <= redAt);
      badge.classList.toggle('inventory--high', !low);
    }

    // Foil styling follows the selected version
    card.classList.toggle('foiled', /\bfoil\b/i.test(title));
  });

  /* Grid toolbar: Sort by (snippets/bgc-collection-toolbar.liquid).
     Reloads with ?sort_by=…, keeps filters/search terms, returns to page 1. */
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.matches || !sel.matches('[data-bgc-sort]')) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });
})();